import Box from '@mui/material/Box';
import { HiOutlineLockClosed } from 'react-icons/hi2';
import { TbCreditCardOff } from 'react-icons/tb';

// Shown on a locked card that the user has never purchased — invites them to buy.
export const UnlockBadge = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontWeight: 600,
      fontSize: '.8rem',
      p: '5px 20px 5px 10px',
      borderRadius: 2,
      background: '#E4E8CA',
      color: theme => theme.palette.grey[900],
      pointerEvents: 'none',
    }}
  >
    Unlock
    <HiOutlineLockClosed size={18} />
  </Box>
);

// Shown on a locked card belonging to an existing customer whose payment lapsed —
// taps through to billing to update their card.
export const PaymentRequiredBadge = () => (
  <Box
    sx={{
      height: '19px',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontWeight: 400,
      fontSize: '9px',
      p: '0px 6px',
      borderRadius: '4px',
      bgcolor: theme => theme.palette.primary.main,
      color: theme => theme.palette.common.white,
      pointerEvents: 'none',
      boxShadow: '0px 2.67px 3.17px 0px #0000001F, 1.14px 1.14px 2.28px 0px #0000003B inset',
    }}
  >
    Payment Required
    <TbCreditCardOff size={12} />
  </Box>
);

export const PaymentRequiredBadgeBg = () => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      bgcolor: '#0A08084D',
    }}
  />
);
